import PanelPopup from './PanelPopup';
import PanelPopupContainer from './PanelPopup.container';
export default PanelPopupContainer(PanelPopup);

//# sourceMappingURL=index.js.map